"use client";

import React from "react";

interface NoiseProps {
  /** Size of the noise pattern (baseFrequency). Typical range: 0.1 to 1.0 */
  noiseSize: number;
  /** Density of the noise pattern (0-1 range) - controls how much noise is visible */
  density: number;
  /** Hex color of the noise (e.g., "#b9b9ff") */
  colour: string;
  /** Unique filter ID to avoid SVG filter conflicts when multiple Noise components are used */
  filterId?: string;
  /** Overall opacity of the noise layer (0-1 range). Defaults to 1. */
  opacity?: number;
  /** CSS mix-blend-mode for the noise overlay. Defaults to 'overlay'. */
  mixBlendMode?: React.CSSProperties["mixBlendMode"];
}

export const Noise: React.FC<NoiseProps> = ({
  noiseSize,
  density,
  colour,
  filterId = "noiseFilter",
  opacity = 1,
  mixBlendMode = "overlay",
}) => {
  const hex = colour.replace("#", "");
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;

  return (
    <svg
      className="noise-overlay"
      width="100%"
      height="100%"
      aria-hidden="true"
      focusable={false}
      style={{ opacity, mixBlendMode }}
    >
      <filter id={filterId}>
        <feTurbulence
          type="fractalNoise"
          baseFrequency={noiseSize}
          numOctaves={4}
          seed={0}
        />
        <feColorMatrix
          type="matrix"
          values={`0 0 0 0 ${r.toFixed(3)}
                  0 0 0 0 ${g.toFixed(3)}
                  0 0 0 0 ${b.toFixed(3)}
                  0 0 0 ${density.toFixed(2)} 0`}
        />
      </filter>
      <rect width="100%" height="100%" filter={`url(#${filterId})`} />
    </svg>
  );
};
